import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

const Header = ({ onScrollToServices, onOpenBooking }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled 
          ? 'bg-[#f5f3ef]/95 backdrop-blur-sm shadow-sm py-3' 
          : 'bg-transparent py-5'
      }`}
    >
      <div className="max-w-6xl mx-auto px-6 flex items-center justify-end">
        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center gap-8">
          <button
            onClick={onScrollToServices}
            className={`text-sm tracking-wider transition-colors duration-300 hover:opacity-70 ${
              isScrolled ? 'text-[#5a6b4e]' : 'text-[#5a6b4e]'
            }`}
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            SZOLGÁLTATÁSOK
          </button>
          <button
            onClick={onOpenBooking}
            className={`text-sm tracking-wider transition-colors duration-300 hover:opacity-70 ${
              isScrolled ? 'text-[#5a6b4e]' : 'text-[#5a6b4e]'
            }`}
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            KAPCSOLAT
          </button>
        </nav>

        {/* Mobile Menu Button */}
        <button 
          className="md:hidden"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          {isMobileMenuOpen ? (
            <X className={`w-6 h-6 ${isScrolled ? 'text-[#5a6b4e]' : 'text-[#5a6b4e]'}`} />
          ) : (
            <Menu className={`w-6 h-6 ${isScrolled ? 'text-[#5a6b4e]' : 'text-[#5a6b4e]'}`} />
          )}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-[#f5f3ef] border-t border-[#e0ddd8]">
          <div className="px-6 py-4 space-y-4">
            <button
              onClick={() => {
                onScrollToServices();
                setIsMobileMenuOpen(false);
              }}
              className="block w-full text-left text-sm tracking-wider text-[#5a6b4e]"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              SZOLGÁLTATÁSOK
            </button>
            <button
              onClick={() => {
                onOpenBooking();
                setIsMobileMenuOpen(false);
              }}
              className="block w-full text-left text-sm tracking-wider text-[#5a6b4e]"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              KAPCSOLAT
            </button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
